"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirectUrlBuilder = void 0;
var query_string_1 = __importDefault(require("query-string"));
var config_1 = require("@skillrecordings/config");
var redirectUrlBuilder = function (subscriber, path, queryParams) {
    var _a;
    var url = query_string_1.default.stringifyUrl({
        url: path,
        query: __assign((_a = {}, _a[config_1.CK_SUBSCRIBER_KEY] = subscriber.id, _a.email = subscriber.email, _a), queryParams),
    });
    return url;
};
exports.redirectUrlBuilder = redirectUrlBuilder;
